import { render, staticRenderFns } from "./Sights.vue?vue&type=template&id=650aed65&"
import script from "./Sights.vue?vue&type=script&lang=js&"
export * from "./Sights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Sights.vue"
export default component.exports